/**
 * frontend/src/constants/featureModules.js
 * ─────────────────────────────────────────────────────────────────────────────
 * Mirror of server-side constants/featureModules.js. Kept in sync by hand.
 *
 * Why a mirror rather than a shared package?
 *   - The SPA is a plain CRA build, no monorepo yarn-workspace setup.
 *   - These constants are read-only string enums — drift is easy to spot and
 *     runs through TypeScript-like prop checks in the admin UI.
 *
 * If a new module is added server-side, add it here too and both tests +
 * the admin grant UI will surface it automatically.
 */

export const FEATURE_MODULES = Object.freeze({
  ACTIVITY_FEED: "ACTIVITY_FEED",
  STOCK_LEDGER: "STOCK_LEDGER",
  REPORTS: "REPORTS",
  DATA_EXPORT: "DATA_EXPORT",
  VERSION_HISTORY: "VERSION_HISTORY",
});

export const FEATURE_MODULE_LIST = Object.freeze(Object.values(FEATURE_MODULES));

export const ENTITLEMENT_STATUS = Object.freeze({
  ACTIVE: "ACTIVE",
  TRIAL: "TRIAL",
  SUSPENDED: "SUSPENDED",
  EXPIRED: "EXPIRED",
  REVOKED: "REVOKED",
  NOT_PROVISIONED: "NOT_PROVISIONED",
});

export const ENTITLEMENT_TIERS = Object.freeze({
  BASIC: "BASIC",
  PRO: "PRO",
  ENTERPRISE: "ENTERPRISE",
});

export const MODULE_LABELS = Object.freeze({
  [FEATURE_MODULES.ACTIVITY_FEED]: "Activity Feed",
  [FEATURE_MODULES.STOCK_LEDGER]: "Stock Ledger",
  [FEATURE_MODULES.REPORTS]: "Reports",
  [FEATURE_MODULES.DATA_EXPORT]: "Data Export",
  [FEATURE_MODULES.VERSION_HISTORY]: "Version History",
});

export const MODULE_DESCRIPTIONS = Object.freeze({
  [FEATURE_MODULES.ACTIVITY_FEED]:
    "Filterable vendor activity log with diff inspection and session drill-down.",
  [FEATURE_MODULES.STOCK_LEDGER]:
    "Immutable inventory movements with on-hand reconciliation.",
  [FEATURE_MODULES.REPORTS]:
    "KPIs, stock insights, customer cohorts, and signed PDF statements.",
  [FEATURE_MODULES.DATA_EXPORT]:
    "CSV downloads on the Data export page: activity, stock, sessions, orders, order lines, catalogue, team and wallet.",
  [FEATURE_MODULES.VERSION_HISTORY]:
    "The order timeline, with the time spent at each stage. Product change history is not controlled by this row.",
});
